import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import moment from "moment";
import Loader from "../../loader";
import AdminHeader from "../../layouts/admin-header";
import AdminFooter from "../../layouts/admin-footer";
import AdminNavBar from "../../layouts/admin-nav-bar";
import { API_URL } from "../../../config/constant";
import "./report.css";

export default function MoneyViewPersonal({ menuAccess }) {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [searchBy, setSearchBy] = useState("");
  const [value, setValue] = useState("");
  const [showTimeline, setShowTimeline] = useState(false);
  const [timelineEvents, setTimelineEvents] = useState([]);
  const [selectedLead, setSelectedLead] = useState(null);
  // Fetch function
  const fetchData = async (searchField, searchValue) => {
    try {
      setLoader(true);
      const res = await axios.post(`${API_URL}mv/callbacks`, {
        searchBy: searchField || undefined,
        value: searchValue || undefined,
      });
      setData(res.data);
    } catch (err) {
      console.error(err);
      setData([]);
    } finally {
      setLoader(false);
    }
  };

  // Initial load → fetch all
  useEffect(() => {
    fetchData();
  }, []);

  const getLatestEvent = (events = []) => {
    if (!events.length) return null;

    return [...events].sort((a, b) => {
      const first = new Date(
        b.record.timestamp || b.record.created_at
      );

      const second = new Date(
        a.record.timestamp || a.record.created_at
      );

      return first - second;
    })[0];
  };

  const openTimeline = (lead) => {
    setSelectedLead(lead);
    setTimelineEvents(lead.events || []);
    setShowTimeline(true);
  };

  const handleSearch = (e) => {
    e.preventDefault();

    if (!searchBy) {
      alert("Please select a search field.");
      return;
    }
    if (!value.trim()) {
      alert("Please enter a value to search.");
      return;
    }

    fetchData(searchBy, value);
  };
  const getStatusClass = (status = "") => {
  switch (status) {
    case "OFFERED":
      return "status-success";

    case "APPROVED":
      return "status-success";

    case "KYC_COMPLETED":
      return "status-primary";

    case "ELIGIBLE":
      return "status-info";

    case "REJECTED":
      return "status-danger";

    default:
      return "status-secondary";
  }
};
  // CSV Download Handler
  const handleDownloadExcel = () => {
    const leadsSheet = data.map((item) => ({
      LeadID: item.lead_id,
      ApplicationNumber: item.loan_application_number,
      CaseNumber: item.case_number,
      Name: item.personal_detail.name,
      Email: item.personal_detail.email_id,
      Phone: item.personal_detail.mobile_number,
      PAN: item.personal_detail.pan_card,
    }));

    const eventsSheet = [];
    data.forEach((item) => {
      (item.events || []).forEach((ev) => {
        let extraDetails = "";
        if (
          ev.record.extra_details &&
          Object.keys(ev.record.extra_details).length > 0
        ) {
          extraDetails = Object.entries(ev.record.extra_details)
            .map(([k, v]) => `• ${k}: ${v}`)
            .join("\n");
        }
        eventsSheet.push({
          LeadID: item.lead_id,
          Status:
            ev.event_type === "OFFERED" ? "PROVISIONAL  OFFER" : ev.event_type,
          Timestamp: ev.record.timestamp
            ? moment(ev.record.timestamp).format("YYYY-MM-DD HH:mm:ss")
            : "-",
          CreatedAt: ev.record.created_at
            ? moment(ev.record.created_at).format("YYYY-MM-DD HH:mm:ss")
            : "-",
          ExtraDetails: extraDetails,
        });
      });
    });

    const wb = XLSX.utils.book_new();
    const ws1 = XLSX.utils.json_to_sheet(leadsSheet);
    const ws2 = XLSX.utils.json_to_sheet(eventsSheet);
    XLSX.utils.book_append_sheet(wb, ws1, "Leads");
    XLSX.utils.book_append_sheet(wb, ws2, "Events");

    XLSX.writeFile(wb, "moneyview_report.xlsx");
  };

  const sortedData = [...data].sort((a, b) => {
    const latestA = getLatestEvent(a.events);
    const latestB = getLatestEvent(b.events);

    return (
      new Date(
        latestB?.record?.timestamp || latestB?.record?.created_at || 0
      ) -
      new Date(
        latestA?.record?.timestamp || latestA?.record?.created_at || 0
      )
    );
  });

  return (
    <>
      {loader && <Loader />}
      <div className="layout-wrapper">
        <div className="layout-container">
          <AdminNavBar menuAccess={menuAccess} />
          <div className="adminMain-wrapper">
            <AdminHeader />
            <div className="mainContent">
              <div className="topHeadings">
                <h3>Personal Loan (Moneyview) Reports</h3>
              </div>

              {/* 🔍 Search Box */}
              <div className="contentBlocks">
                <form
                  onSubmit={handleSearch}
                  style={{ display: "flex", gap: "10px", marginBottom: "15px" }}
                >
                  <select
                    value={searchBy}
                    onChange={(e) => setSearchBy(e.target.value)}
                    style={{ padding: "6px" }}
                  >
                    <option value="">-- Search By --</option>
                    <option value="case_number">Case Number</option>
                    <option value="email_id">Email</option>
                    <option value="mobile_number">Mobile Number</option>
                    <option value="name">Name</option>
                    <option value="pan_card">PAN</option>
                  </select>
                  <input
                    type="text"
                    placeholder="Enter value"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                  />
                  <button
                    type="submit"
                    style={{
                      background: "#02bd64",
                      color: "#fff",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setSearchBy("");
                      setValue("");
                      fetchData(); // reset → all records
                    }}
                    style={{
                      background: "#999",
                      color: "#fff",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    Reset
                  </button>
                  <div
                    style={{
                      border: "1px solid #ccc",
                      padding: "5px 25px",
                      backgroundColor: "#02bd64",
                      borderRadius: "5px",
                      cursor: "pointer",
                      color: "#fff",
                      display: "inline-block",
                    }}
                    onClick={handleDownloadExcel}
                  >
                    Download Report
                  </div>
                </form>

                <div className="sectionTable">
                  <div className="continer-fluid">
                    <div className="row">
                      <div className="col-lg-12 col-md-9 col-xs-12">
                          <div className="tableLeadCase">
                            <div className="table-responsive custom-table-wrapper">
                            <table
                              className="table table-stripped"
                            >
                              <thead>
                                <tr>
                                  <th className="table-head">Lead ID</th>
                                  <th className="table-head">Case Number</th>
                                  <th className="table-head">Applicant Name</th>
                                  <th className="table-head">Email Id</th>
                                  <th className="table-head">Phone Number</th>
                                  <th className="table-head">PAN Number</th>
                                  <th>Latest Status</th>
                                  <th>Status Time</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                sortedData.map((item, idx) => {
                                  const latestEvent = getLatestEvent(item.events);
                                  return (
                                  <React.Fragment key={idx}>
                                    <tr
                                    >
                                      <td>{item.lead_id}</td>
                                      <td>{item.case_number}</td>
                                      <td>{item.personal_detail.name}</td>
                                      <td>{item.personal_detail.email_id}</td>
                                      <td>
                                        {item.personal_detail.mobile_number}
                                      </td>
                                      <td>{item.personal_detail.pan_card}</td>
                                      <td>
                                          <span className={`status-badge ${getStatusClass(latestEvent?.event_type)}`}>
                                              {latestEvent?.event_type === "OFFERED"
                                                  ? "PROVISIONAL OFFER"
                                                  : latestEvent?.event_type || "-"}
                                          </span>
                                      </td>

                                      <td>
                                        {latestEvent
                                          ? moment(
                                              latestEvent.record.timestamp ||
                                                latestEvent.record.created_at
                                            ).format("YYYY-MM-DD HH:mm:ss")
                                          : "-"}
                                      </td>

                                      <td>
                                        <button
                                          className="btn btn-primary btn-sm"
                                          onClick={() => openTimeline(item)}
                                        >
                                          View Timeline
                                        </button>
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                )})}
                              </tbody>
                            </table>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {showTimeline && selectedLead && (
              <div
                  className="modal fade show"
                  style={{
                      display: "block",
                      background: "rgba(0,0,0,.65)",
                      overflowY: "auto"
                  }}
              >
                  <div className="modal-dialog modal-xl timeline-modal">
                      <div className="modal-content">

                          <div className="modal-header">

                              <div>

                                  <h4 className="mb-1">
                                      Lead Details
                                  </h4>

                                  <small>
                                      {selectedLead.case_number}
                                  </small>

                              </div>

                              <button
                                  className="btn-close"
                                  onClick={() => setShowTimeline(false)}
                              />

                          </div>

                          <div className="modal-body">

                              {/* Lead Summary */}

                              <div className="row mb-4">

                                  <div className="col-md-4">

                                      <div className="detail-card">

                                          <label>Lead ID</label>

                                          <h6>{selectedLead.lead_id}</h6>

                                      </div>

                                  </div>

                                  <div className="col-md-4">

                                      <div className="detail-card">

                                          <label>Application No.</label>

                                          <h6>{selectedLead.loan_application_number || "-"}</h6>

                                      </div>

                                  </div>

                                  <div className="col-md-4">

                                      <div className="detail-card">

                                          <label>Case Number</label>

                                          <h6>{selectedLead.case_number}</h6>

                                      </div>

                                  </div>

                              </div>


                              {/* Applicant Details */}

                              <div className="card mb-4">

                                  <div className="card-header">

                                      Applicant Details

                                  </div>

                                  <div className="card-body">

                                      <div className="row">

                                          <div className="col-md-6 mb-3">
                                              <label>Name</label>
                                              <h6>{selectedLead.personal_detail.name}</h6>
                                          </div>

                                          <div className="col-md-6 mb-3">
                                              <label>Email</label>
                                              <h6>{selectedLead.personal_detail.email_id}</h6>
                                          </div>

                                          <div className="col-md-6 mb-3">
                                              <label>Mobile</label>
                                              <h6>{selectedLead.personal_detail.mobile_number}</h6>
                                          </div>

                                          <div className="col-md-6 mb-3">
                                              <label>PAN</label>
                                              <h6>{selectedLead.personal_detail.pan_card}</h6>
                                          </div>

                                      </div>

                                  </div>

                              </div>


                              {/* Timeline */}

                              <div className="card">

                                  <div className="card-header">

                                      Status Timeline

                                  </div>

                                  <div className="card-body">

                                      <div className="timeline">

                                          {timelineEvents
                                            .sort((a, b) => {
                                              return (
                                                new Date(b.record.timestamp || b.record.created_at) -
                                                new Date(a.record.timestamp || a.record.created_at)
                                              );
                                            })
                                              .map((event, index) => (

                                                  <div
                                                      className="timeline-item"
                                                      key={index}
                                                  >

                                                      <div className="timeline-dot"></div>

                                                      <div className="timeline-card">

                                                          <div className="d-flex justify-content-between align-items-center">

                                                              <h6 className="timeline-title mb-0">

                                                                  {event.event_type === "OFFERED"
                                                                      ? "PROVISIONAL OFFER"
                                                                      : event.event_type}

                                                              </h6>

                                                              <span className="timeline-time">

                                                                  {moment(
                                                                      event.record.timestamp ||
                                                                      event.record.created_at
                                                                  ).format("DD MMM YYYY hh:mm A")}

                                                              </span>

                                                          </div>

                                                          {event.record.extra_details &&
                                                              Object.keys(event.record.extra_details).length > 0 && (

                                                                  <div className="row mt-3">

                                                                      {Object.entries(event.record.extra_details).map(([key, value]) => (

                                                                          <div
                                                                              className="col-md-6 mb-2"
                                                                              key={key}
                                                                          >

                                                                              <strong>{key}</strong>

                                                                              <div>{String(value)}</div>

                                                                          </div>

                                                                      ))}

                                                                  </div>

                                                              )}

                                                      </div>

                                                  </div>

                                              ))}

                                      </div>

                                  </div>

                              </div>

                          </div>

                          <div className="modal-footer">

                              <button
                                  className="btn btn-secondary"
                                  onClick={() => setShowTimeline(false)}
                              >
                                  Close
                              </button>

                          </div>

                      </div>
                  </div>
              </div>
          )}
            <AdminFooter />
          </div>
        </div>
      </div>
    </>
  );
}
